<template>
  <v-widget
    :title="$t('Profile Information')"
    class="mb-4"
  >
    <div slot="widget-content">
      <v-form>
        <v-text-field
          v-model="user.name"
          :error-count="user.displayErrors('name').length"
          :error-messages="user.displayErrors('name')"
          :label="$t('Name')"
          outline
        />
        <v-text-field
          v-model="user.email"
          :error-count="user.displayErrors('email').length"
          :error-messages="user.displayErrors('email')"
          :label="$t('Email')"
          outline
        />
        <v-text-field
          v-model="user.type"
          :error-count="user.displayErrors('type').length"
          :error-messages="user.displayErrors('type')"
          :label="$t('Type')"
          outline
          disabled
        />
        <v-text-field
          v-if="user.type==='customer'"
          v-model="user.customer_id"
          :error-count="user.displayErrors('customer_id').length"
          :error-messages="user.displayErrors('customer_id')"
          :label="$t('Customer ID')"
          outline
          disabled
        />
      </v-form>
    </div>
  </v-widget>
</template>

<script>
export default {
  name: 'UserProfile',

  props: {
    user: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      menu: false
    }
  }
}
</script>
